/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Move_ConfirmInputs */

const en_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move`)
};

const fr_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer`)
};

const de_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewegen`)
};

const it_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mossa`)
};

const ru_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двигаться`)
};

const es_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover`)
};

const zh_cn2_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移动`)
};

const ja_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動く`)
};

const hi_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कदम`)
};

const pt_pt2_explorer_table_move_confirm = /** @type {(inputs: Explorer_Table_Move_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover`)
};

/**
* | output |
* | --- |
* | "Move" |
*
* @param {Explorer_Table_Move_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_move_confirm = /** @type {((inputs?: Explorer_Table_Move_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Move_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_move_confirm(inputs)
	if (locale === "de") return de_explorer_table_move_confirm(inputs)
	if (locale === "it") return it_explorer_table_move_confirm(inputs)
	if (locale === "ru") return ru_explorer_table_move_confirm(inputs)
	if (locale === "es") return es_explorer_table_move_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_move_confirm(inputs)
	if (locale === "ja") return ja_explorer_table_move_confirm(inputs)
	if (locale === "hi") return hi_explorer_table_move_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_move_confirm(inputs)
	return en_explorer_table_move_confirm(inputs)
});